import Vue from 'vue'
import Router from 'vue-router';


Vue.use(Router)

const router= new Router({
  routes: [

    {
      path: "/",
      name: "bms",
      title: "空页面",
      component: resolve => require(['@/pages/bms/index'], resolve),
      meta: { requireAuth: false,   title: "空页面" },
      children: [
        {
          path: "/bms/base",
          name: "empty",
          title: "空页面",
          component: resolve => require(['@/pages/bms/base/index'], resolve),
          meta: { requireAuth: false,   title: "空页面", }
        },

        {
          path: "/bms/set",
          name: "empty",
          title: "参数设置",
          component: resolve => require(['@/pages/bms/set/index'], resolve),
          meta: { requireAuth: false,   title: "空页面", }
        }
        ]
    }




  ]
})

const originalPush = Router.prototype.push

Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)

}
export default router



// WEBPACK FOOTER //
// ./src/router/index2.js